import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: null,
};

const userSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUser(state, action) {
      state.userInfo = action.payload;
    },
    addMemberships(state, action) {
      state.memberships = action.payload;
    },
  },
});

export const { setUser, addMemberships } = userSlice.actions;
export default userSlice.reducer;
